import { PropTypes } from 'prop-types';
import { useFormContext } from 'react-hook-form';

import Fieldset from '#client/components/Fieldset';

import Address1Field from './components/Address1Field';
import Address2Field from './components/Address2Field';
import CityField from './components/CityField';
import PostalCodeField from './components/PostalCodeField';
import StateField from './components/StateField';

function AddressFieldset({ fieldsConfig, namePrefix }) {
  const { formState } = useFormContext();
  const { isSubmitting } = formState;

  const { address1, address2, city, state, postalCode } = fieldsConfig || {};
  const { show: showAddress1, ...address1Props } = address1 || {};
  const { show: showAddress2, ...address2Props } = address2 || {};
  const { show: showCity, ...cityProps } = city || {};
  const { show: showState, ...stateProps } = state || {};
  const { show: showPostalCode, ...postalCodeProps } = postalCode || {};

  return (
    <Fieldset disabled={isSubmitting} gap={1}>
      {showAddress1 && <Address1Field {...address1Props} namePrefix={namePrefix} />}
      {showAddress2 && <Address2Field {...address2Props} namePrefix={namePrefix} />}
      {showCity && <CityField {...cityProps} namePrefix={namePrefix} />}
      {showState && <StateField {...stateProps} namePrefix={namePrefix} />}
      {showPostalCode && <PostalCodeField {...postalCodeProps} namePrefix={namePrefix} />}
    </Fieldset>
  );
}

AddressFieldset.propTypes = {
  fieldsConfig: PropTypes.shape({
    address1: PropTypes.object,
    address2: PropTypes.object,
    city: PropTypes.object,
    state: PropTypes.object,
    postalCode: PropTypes.object
  }).isRequired,
  namePrefix: PropTypes.string
};

export default AddressFieldset;
